import React from 'react';

import LangBanner from './LangBanner';
import './banners.css';

const langBannerClosedKey = '__or__langBannerClosed';
const getLangBannerClosed = () =>
  localStorage.getItem(langBannerClosedKey) === '1';

/** SaaS copy of the FOSS notices without `AlertsBanner`: the account's alerts
 *  show above the app (`saas/layout/AppBanners.tsx`), so they never show twice. */
function HeaderBanners() {
  const [langBannerClosed, setLangBannerClosed] =
    React.useState(getLangBannerClosed);

  React.useEffect(() => {
    const langBannerVal = localStorage.getItem(langBannerClosedKey);
    if (langBannerVal === null) {
      localStorage.setItem(langBannerClosedKey, '0');
    }
    if (langBannerVal === '0') {
      localStorage.setItem(langBannerClosedKey, '1');
    }
  }, []);

  const closeLangBanner = () => {
    setLangBannerClosed(true);
    localStorage.setItem(langBannerClosedKey, '1');
  };

  if (langBannerClosed) return null;
  return (
    <div className="m-shell__notices">
      <LangBanner onClose={closeLangBanner} />
    </div>
  );
}

export default HeaderBanners;
